import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

const FONT_SIZES = {
  h1: "3rem",
  h2: "2rem",
  h3: "1.5rem",
  h4: "1.13rem",
  h5: "1.08rem",
  body: "1rem",
  body2: "0.88rem",
  body3: "0.75rem",
  body4: "0.68rem",
};

// Create a theme instance.
export const theme = createTheme({
  spacing: 4,
  typography: {
    fontSize: 20,
    fontFamily: [
      // '"Segoe UI"',
      "Kulim Park",
      "Roboto",
      "Arial",
      "sans-serif",
    ].join(","),
    ...FONT_SIZES,
    useNextVariants: true,
  },
  palette: {
    background: {
      default: "#fff",
      muted: "rgba(217, 231, 255, 0.5)",
      dark: "#0a2f4e",
    },
    primary: {
      main: "#FDC606",
      dark: "#EBB709",
      light: "#FBF8F3",
    },
    secondary: {
      main: "#2D3246",
      light: "#ABADB5",
    },
    accent: {
      main: "rgb(129,65,141)",
    },
    danger: {
      main: red.A400,
    },
    grays: {
      white: "#fff",
      100: "#f6f8fa",
      200: "#f0f2f5",
      300: "#e4e6ef",
      400: "#C4C5D0",
      500: "#b6b6c4",
      600: "#a2a6b8",
      700: "#7e8299",
      800: "#5e6278",
      900: "#404254",
      black: "#333333",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 25,
          fontSize: "14px",
          fontWeight: 500,
          gap: 2,
          height: "fit-content",
          letterSpacing: 2,
          paddingBottom: 12,
          paddingLeft: 22,
          paddingRight: 20,
          paddingTop: 12,
          textTransform: "capitalize",
          transition: "all 0.5s ease-in-out",
          width: "fit-content",
        },
        contained: {
          boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.08)",
          "&:hover": {
            boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.08)",
          },
        },
        outlined: {
          boxShadow: "1px 1px 2px rgba(0, 0, 0, 0.08)",
          "&:hover": {
            border: `1px solid ${"#e4e6ef"}`,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          // background: "linear-gradient(90deg, #7C1CFD -5.73%, #139AF6 88.78%)",
        },
      },
    },
  },
});

export const appBar = {
  height: 76,
  width: "100%",
};

export const body = {
  color: "#5e6278", // grays[700]
  fontSize: 20, // x1
  fontWeight: 400,
  maxWidth: 1250,
  width: "95%",
};

export const glass = {
  background: "rgba(255, 255, 255, 0.6)",
  backdropFilter: "saturate(180%) blur(20px)",
  border: "1px solid rgba(255, 255, 255, 0.3)",
  boxShadow: "0px 4px 12px rgba(184, 184, 184, 0.25)",
};
